import { StyleSheet } from "react-native";
import { theme } from "@clearabee/ui-library-native";

export const styles = StyleSheet.create({
  smallPanel: {
    padding: theme.spacing.small,
  },
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: theme.spacing.xlarge,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.greyscale.lighter,
  },
  product: {
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    paddingVertical: theme.spacing.xsmall,
    borderTopColor: theme.colors.greyscale.lightest,
  },
  largeProduct: {
    alignItems: "center",
    flexDirection: "row",
    borderTopColor: theme.colors.greyscale.lightest,
    paddingBottom: theme.spacing.large,
  },
  largeQuantity: {
    alignItems: "center",
    paddingBottom: theme.spacing.large,
  },
  heading: {
    fontFamily: "ProximaSemiBold",
    textTransform: "uppercase",
    marginBottom: theme.spacing.xsmall2,
  },
  documentsText: {
    width: "100%",
    paddingBottom: theme.spacing.small,
    fontWeight: "bold",
    borderBottomColor: theme.colors.greyscale.lightest,
    borderBottomWidth: 2,
  },
  linksContainer: {
    display: "flex",
    gap: theme.spacing.small,
  },
  resourcesPanel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.spacing.small,
    padding: theme.spacing.medium,
    marginBottom: theme.spacing.small,
  },
});
